import React from 'react';
import { Hero } from '../components/landing/sections/Hero';
import { Features } from '../components/landing/sections/Features';
import { Demo } from '../components/landing/sections/Demo';
import { Benefits } from '../components/landing/sections/Benefits';
import { UseCases } from '../components/landing/sections/UseCases';
import { Technology } from '../components/landing/sections/Technology';
import { Pricing } from '../components/landing/sections/Pricing';
import { FinalCTA } from '../components/landing/sections/FinalCTA';
import { Navbar } from '../components/landing/navigation/Navbar';
import { Footer } from '../components/landing/Footer';

const LandingPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-slate-900 to-black">
      <Navbar />
      <main>
        <Hero />
        <Features />
        <Demo />
        <Benefits />
        <UseCases />
        <Technology />
        <Pricing />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
